import React, {memo, useEffect} from "react";
import {useLocation} from "react-router-dom";

import {useAppKit, useAppKitAccount, useDisconnect} from "@reown/appkit/react";
import classNames from "classnames";

import {useAuthorization, useConnectedWallet} from "hooks";
import {useGlobalModalsContext} from "layouts";
import {ERROR, GLOBAL_MODALS, wait} from "utils";

import {WalletIcon} from "assets/svg";
import "./style.scss"

const WalletConnect = ({setIsOpenUserMenu}) => {
    const {setModal, setMessage, resetStatesAndClose} = useGlobalModalsContext()
    const {isConnectedAddressCorrect} = useConnectedWallet()
    const {isConnected,address} = useAppKitAccount();
    const {disconnect} = useDisconnect()
    const {isAuth} = useAuthorization()
    const {open} = useAppKit();

    const location = useLocation()

    const walletStyle = classNames("wallet-connect", {"connected": isConnected})

    useEffect(() => {
        checkConnectedWallet()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected,address]);

    const checkConnectedWallet = async () => {
        if (isConnected && isAuth && location.pathname !== "/profile" && !isConnectedAddressCorrect) {

            setModal(GLOBAL_MODALS.ERROR)
            setMessage(ERROR.WALLET_CONNECTED_MATCH_INVALID)

            await wait(3000)
            resetStatesAndClose()

            await disconnect({namespace:"eip155"})
        }
    }

    return (
        <button onClick={() => isConnected ? setIsOpenUserMenu() : open()} className={walletStyle}>
            <WalletIcon/>
        </button>
    )
}

export default memo(WalletConnect)